export default __webpack_public_path__ + "static/dark-61311ffe65ef425e08c1a021b3c4d34f.png";